class PreviewSection extends React.Component {

    //The props is passed from the view(cshtml)
    constructor(props) {
        super(props);
        this.state = PreviewSection.modelToState(props);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    //set the react state to the the same values as the model
    static modelToState(props) {
        return {
            ListingDetailViewModel: props.model.ListingDetailViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            FitsToViewModel: props.model.FitsToViewModel,
            MediaViewModel: props.model.MediaViewModel,
            PriceViewModel: props.model.PriceViewModel,
            ContactViewModel: props.model.ContactViewModel,
            CurrentSite: props.model.CurrentSite,
            QueryString: props.model.QueryString,
            Translations: props.model.Translations,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            IsInTranslationEditorMode: props.model.IsInTranslationEditorMode,
            IsRearrangedDetailsPage: props.model.IsRearrangedDetailsPage
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            ListingDetailViewModel: props.model.ListingDetailViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            FitsToViewModel: props.model.FitsToViewModel,
            PriceViewModel: props.model.PriceViewModel,
            MediaViewModel: props.model.MediaViewModel,
            ContactViewModel: props.model.ContactViewModel
        });
    }

    //executes a command when you click on a button
    handleButtonClick(button) {
        var state = this.state;

        switch (button) {
            case "save":
                if (this.props.model.IsRegisteredUser || this.state.ContactViewModel.EmailVerified) {
                    SaveAndExitModal();
                }
                else {
                    //close all other sections, go directly to contact section to ask them to create an account to save
                    if ($("#saveExitMessage").text() == this.getTranslation("saveExitMessageCreateAccount")) {
                        this.props.model.SaveExitMethod("exitNewUser");
                    }
                    else {
                        if (this.state.ContactViewModel.EmailIsRegistered) {
                            $("#saveExitMessage").text(this.getTranslation("saveExitMessageVerify"));
                            $("#VerifyPasswordSection").hide();
                            $("#VerifyPasswordSaveAndExit").fadeIn();
                        }
                        else {
                            $("#saveExitMessage").text(this.getTranslation("saveExitMessageCreateAccount"));
                        }

                        $("#saveExitMessage").fadeIn();
                        $("#SavedFor30Days").fadeIn();
                        OpenSpecificHeaderAccordion(ContactSectionID);
                        $('input[id="Email"]').focus();
                            $("#SubmitBtn").hide();
                            $("#submit-section").fadeIn();
                    }
                }

                window.scrollTo({ top: 0, behavior: 'smooth' });
                break;
            case "help":
                $("#saveExitMessage").fadeOut();
                $("#SavedFor30Days").fadeOut();
                break;
        }
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    //the html and react components to render
    render() {
        let showContact = true;
        let showAddress = true;
        let showCityState = true;
        let showDescription = true;
        let showPrice = true;
        let showPhone = true;

        if (this.state.CurrentSite == "Aircraft") {
            showContact = false;
            showAddress = false;
            showCityState = false;
            showDescription = false;
            showPrice = false;
        }
        if (this.props.model.IsConsignment) {
            showPrice = false;
            showContact = false;
            showAddress = false;
        }

        if (this.state.IsRearrangedDetailsPage) {
            showPhone = false;
        }

        // Header Text - On attachments, if make/model are empty, then show category full name with Year
        var headerText = (this.state.ListingDetailViewModel.ManufacturerSelected != "" ? (this.state.ListingDetailViewModel.ManufacturerSelected + " ") : "") +
            (this.state.ListingDetailViewModel.ModelSelected != "" ? (this.state.ListingDetailViewModel.ModelSelected + " ") : "")

        if (headerText == "" && this.state.ListingDetailViewModel.IsAttachment && this.state.ListingDetailViewModel.CategorySelected != "0") {
            var catOption = null
            var state = this.state;
            this.state.ListingDetailViewModel.CategoriesList.filter(function (Category) {
                if (Category.Value == state.ListingDetailViewModel.CategorySelected) {
                    catOption = Category;
                    return Category;
                }
            })
            headerText = catOption.FullName.trim()
        }

        if (this.state.ListingDetailViewModel.YearSelected != "")
            headerText = this.state.ListingDetailViewModel.YearSelected + " " + headerText;

        var title = [];
        if (headerText == "") {
            title.push(
                <h2 key="headerText" className="preview-title" style={{ color: '#747575' }}>
                    {this.getTranslation("TitlePlaceholder")}
                </h2>
            );
        }
        else {
            title.push(
                <h2 key="headerText" className="preview-title" style={{ color: 'black' }}>
                    {headerText}
                </h2>
            );
        }
            
        var price = [];
        if (showPrice) {
            if (this.state.CurrentSite == "Controller" ||
                this.state.CurrentSite == "Aviation Trader" ||
                this.state.CurrentSite == "Controller EMEA") {
                var bNoPrice = true;
                if (this.state.PriceViewModel.Price != "0" && this.state.PriceViewModel.Price != "" && this.state.PriceViewModel.ForSale) {
                    bNoPrice = false;
                    price.push(
                        <div key="forSale" style={{ paddingBottom: '20px' }}>
                            <div className="preview-price" style={{ marginTop: "5px", fontSize: "14px" }}>
                                For Sale
                            </div>
                            <div className="preview-price" style={{ color: 'black' }}>
                                {this.state.PriceViewModel.FormattedPrice != "" ? this.state.PriceViewModel.CurrencyCodeSelected : ""} {this.state.PriceViewModel.FormattedPrice}
                            </div>
                        </div>
                    );
                }
                if (this.state.PriceViewModel.LeasePrice != "0" && this.state.PriceViewModel.LeasePrice != "" && this.state.PriceViewModel.ForLease) {
                    bNoPrice = false;
                    price.push(
                        <div key="leasePrice" style={{ paddingBottom: '20px' }}>
                            <div className="preview-price" style={{ marginTop: "5px", fontSize: "14px" }}>
                                Lease Price
                            </div>
                            <div className="preview-price" style={{ color: 'black' }}>
                                {this.state.PriceViewModel.FormattedLeasePrice != "" ? this.state.PriceViewModel.CurrencyCodeSelected : ""} {this.state.PriceViewModel.FormattedLeasePrice}
                            </div>
                        </div>
                    );
                }
                if (this.state.PriceViewModel.FractionalPrice != "0" && this.state.PriceViewModel.FractionalPrice != "" && this.state.PriceViewModel.ForFractional) {
                    bNoPrice = false;
                    price.push(
                        <div key="fractionalPrice" style={{ paddingBottom: '20px' }}>
                            <div className="preview-price" style={{ marginTop: "5px", fontSize: "14px" }}>
                                {this.state.PriceViewModel.FractionalPercent == "0" ? "" : this.state.PriceViewModel.FractionalPercent} Fractional Ownership
                            </div>
                            <div className="preview-price" style={{ color: 'black' }}>
                                {this.state.PriceViewModel.FormattedFractionalPrice != "" ? this.state.PriceViewModel.CurrencyCodeSelected : ""} {this.state.PriceViewModel.FormattedFractionalPrice}
                            </div>
                        </div>
                    );
                }
                if (bNoPrice) {
                    price.push(
                        <div key="price" className="preview-price" style={{ color: '#747575', paddingBottom: '20px' }}>
                            {this.getTranslation("Price")}: {this.getTranslation("Call")}
                        </div>
                    );
                }
            }
            else {
                if (this.state.PriceViewModel.Price == "0" || this.state.PriceViewModel.Price == "") {
                    price.push(
                        <div key="callForPrice" className="preview-price" style={{ color: '#747575', paddingBottom: '20px' }}>
                            {this.getTranslation("Price")}: {this.getTranslation("Call")}
                        </div>
                    );
                }
                else {
                    price.push(
                        <div key="price" className="preview-price" style={{ color: 'black', paddingBottom: '20px' }}>
                            {this.state.PriceViewModel.FormattedPrice != "" ? this.state.PriceViewModel.CurrencyCodeSelected : ""} {this.state.PriceViewModel.FormattedPrice}
                        </div>
                    );
                }
            }
        }

        var description = [];
        if (showDescription) {
            if (this.state.ListingDetailViewModel.Description == "") {
                description.push(
                    <div key="descriptionPlaceholder" className="preview-description" style={{ color: '#747575', paddingBottom: '20px' }}>
                        {this.getTranslation("DescriptionPlaceholder")}
                    </div>
                );
            }
            else {
                description.push(
                    <div key="description" className="preview-description" style={{ maxHeight: '15vh', overflowY: 'hidden', overflowX: 'hidden', color: 'black', paddingBottom: '20px' }}>
                        {this.state.ListingDetailViewModel.Description + " "}
                    </div>
                );
            }
        }

        var name = [];
        if (showContact) {
            if (this.state.ContactViewModel.FirstName == "" && this.state.ContactViewModel.LastName == "") {
                name.push(
                    <div key="namePlaceholder" className="preview-name" style={{ color: '#747575', paddingBottom: '20px' }}>
                        {this.getTranslation("NamePlaceholder")}
                    </div>
                );
            }
            else {
                name.push(
                    <div key="name" className="preview-name" style={{ color: 'black', paddingBottom: '20px' }}>
                        {this.state.ContactViewModel.FirstName + " " + this.state.ContactViewModel.LastName}
                    </div>
                );
            }
        }

        var contact = [];
        if (showContact) {
            if (this.state.ContactViewModel.Phone == "") {
                contact.push(
                    <div key="contactPlaceholder" className="preview-contact" style={{ color: '#747575' }}>
                        {this.getTranslation("PhonePlaceholder")}
                    </div>
                );
            }
            else if (showPhone) {
                contact.push(
                    <div key="contact" className="preview-contact" style={{ color: 'black' }}>
                        {this.state.ContactViewModel.Phone}
                    </div>
                );
            }  
        }

        var cityState = [];
        if (showCityState) {
            var locVM = this.state.ContactViewModel.LocationViewModel;
            var city = locVM.City || '';
            var st = locVM.State || '';
            var country = locVM.Country || '';
            var cityStateText = city ? (st ? city + ', ' + st : city) : st;
            if (!cityStateText && country) cityStateText = country;

            if (cityStateText == "") {
                cityState.push(
                    <div key="locationPlaceholder" className="preview-cityState" style={{ color: '#747575' }}>
                        {this.getTranslation("LocationPlaceholder")}
                    </div>
                );
            }
            else {
                cityState.push(
                    <div key="location" className="preview-cityState" style={{ color: 'black' }}>
                        {cityStateText}
                    </div>
                );
            } 
        }

        var saveAndExitBtn = [];
        if (this.state.CurrentSite != "AuctionTime" &&
            this.state.CurrentSite != "AuctionValues" &&
            !this.state.IsRearrangedDetailsPage)
            saveAndExitBtn.push(<button role="link" key="saveExitbutton" className="side-btn save-exit-btn" onClick={(e) => { this.handleButtonClick("save"); }}> {this.getTranslation("SaveAndExit")}</button>);

        //Render each of the sections here
        return (
            <div className="side-container" id="box">
                {this.getTranslation("QuickPreview")}
                <div className="preview-box">
                    {title}

                    <div className="preview-selected-image" onClick={(e) => { OpenMediaFullSize(e) }}>
                        {/*Preview Image handled in JQUERY with media tool*/}
                    </div>
                    <div className="thumbnails" style={{ paddingBottom: '20px' }}>
                        {/*Thumbnails handled in JQUERY with media tool*/}
                    </div>

                    {price}
                    {description}
                    {name}
                    {contact}
                    {cityState}
                </div>
                {saveAndExitBtn}
                <div className="help-side PrimaryBGC">
                    <h2>{this.getTranslation("NeedHelp")}</h2>
                    <div className="help-buttons">
                        <a className="help-text" href={"tel:1-" + this.props.model.HelpPhoneNumber}>
                            <i className="fa fa-phone" aria-hidden="true"></i> &nbsp; {this.props.model.HelpPhoneNumber}
                        </a>
                        <a className="help-email" href={this.props.model.FeedBackEmailLink} title={this.getTranslation("OpensInANewTab")} target="_blank">
                            <i className="fa fa-envelope" aria-hidden="true"></i> &nbsp; {this.getTranslation("Contact")}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default PreviewSection;
global.PreviewSection = PreviewSection;